import React, { Component }  from 'react';
import axios from "axios";
import Layout from "./Components/Layout";
import 'react-datepicker/dist/react-datepicker.css'
import PaginatedItems from "./Components/Pagination";

const badgeStyles = `
.table-container {
    max-height: calc(100vh - 380px);
    overflow-y: auto;
}
.table-container thead th {
    position: sticky;
    top: 0;
    z-index: 10;
    background: #f8f9fa !important;
}
`;

export class Raws extends Component{
    state = {
        records: [],
        search: "",
        show: false,
        popupIndex: 0,
        filtered: false,
        pageNumber:1,
        totalItems: 0,
        perPage: parseInt(localStorage.getItem('rawsPerPage')) || 25
    }

    getCategoryByIdRange = (id) => {
        const numId = parseInt(id);
        if (numId >= 0 && numId <= 9999) return "Template";
        if (numId >= 10000 && numId <= 19999) return "Container";
        if (numId >= 20000 && numId <= 29999) return "Closure";
        if (numId >= 30000 && numId <= 39999) return "Open";
        if (numId >= 40000 && numId <= 49999) return "Open";
        if (numId >= 50000 && numId <= 59999) return "Open";
        if (numId >= 60000 && numId <= 69999) return "Raw Material";
        if (numId >= 70000 && numId <= 79999) return "Secondary Packaging";
        if (numId >= 80000 && numId <= 89999) return "Ancillary Packaging";
        if (numId >= 90000 && numId <= 99999) return "Consumable";
        return "";
    }

    componentDidMount() {
        let pageUrlValue = window.location.href.split('/')[4]
        if(pageUrlValue !== undefined) {
            const selectedOption = parseInt(pageUrlValue)
            this.setState({ selectedOption });
            this.getSuppliers(1, selectedOption)
        } else {
            this.getSuppliers()
        }

    }


    getSuppliers(pageNumber = 1, selectedOption = 0) {
        let _self = this;

        let dataObj = {
            search: _self.state.search,
            order: 'desc',
            page:pageNumber,
            filterByCompany: selectedOption,
            per_page: _self.state.perPage
        }

        if(_self.state.search !== "") {
            const filtered = true;
            _self.setState({ filtered });
        } else {
            const filtered = false;
            _self.setState({ filtered });
        }

        axios.put(`raws/get-raws`, dataObj)
            .then(response => {
                const records = response.data.records;
                _self.setState({ records });

                const totalItems = response.data.total_records
                _self.setState({ totalItems });
            }).catch(error => {
            console.error('There was an error!', error);
        });
    }

    onSearchClick(e)
    {
        this.setState({ pageNumber: 1 }, () => {
            this.getSuppliers(1, this.state.selectedOption);
        });
    }
    

    onSearch(e)
    {
        const search = e.target.value;
        this.setState({ search });
        if (this.searchTimeout) clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
            this.setState({ pageNumber: 1 }, () => {
                this.getSuppliers(1, this.state.selectedOption);
            });
        }, 300);
    }

    componentWillUnmount() {
        if (this.searchTimeout) clearTimeout(this.searchTimeout);
    }

    onKeyUp (e)
    {
        if (e.charCode === 13) {
            console.log('13');
            this.onSearchClick(e);
        }
    };

    openPage(e, dataId){
        e.preventDefault();
        window.location.href = "/view-raws/"+dataId;
    }

    onAddClick(e){
        e.preventDefault();
        window.location.href = "/add-raws";
    }

    paginatePage = (page)=> {
        console.log(`pageNumber ! ${page}`)
        const pageNumber = page
        this.setState({ pageNumber });
        this.getSuppliers(page, this.state.selectedOption);
    }

    onPerPageChange(e) {
        const perPage = parseInt(e.target.value);
        localStorage.setItem('rawsPerPage', perPage);
        this.setState({ perPage, pageNumber: 1 }, () => {
            this.getSuppliers(1, this.state.selectedOption);
        });
    }


    render() {
        return (
            <Layout>
                <style>{badgeStyles}</style>
                <div style={{ height: 'calc(100vh - 70px)', overflow: 'hidden', paddingTop: '20px' }}>
                    <section className="section pb-0" style={{ marginBottom: '0px', paddingTop: '20px', paddingBottom: '0px' }}>
                        <div className="container-fluid" style={{ paddingLeft: '24px' }}>
                            
                            {/* Header Section */}
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <p style={{ color: '#6b7280', fontSize: '16px', margin: 0 }}>Manage and track all parts inventory</p>
                                <div className="d-flex" style={{ gap: '10px' }}>
                                    <a href="/add-raws" className="btn btn-primary btn-sm d-flex align-items-center" style={{ gap: '8px', padding: '8px 16px', textDecoration: 'none' }}>
                                        <i className="ti-plus"></i>
                                        Add New Part
                                    </a>
                                </div>
                            </div>

                            <div className="row" style={{'@media print': {display: 'none'}}}>
                                <div className="col-lg-12 mb-3">

                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="input-group">
                                                <input 
                                                    type="text" 
                                                    className="form-control"
                                                    onKeyPress={(e) => this.onKeyUp(e)}
                                                    onChange={(e) => this.onSearch(e)}
                                                    placeholder="Search by ingredient, SKU or material name..."
                                                    value={this.state.search}
                                                    style={{padding: '20px'}} 
                                                    aria-describedby="basic-addon2"
                                                />
                                                <div className="input-group-append">
                                                    <span onClick={(e) => this.onSearchClick(e)} className="input-group-text ti-search" id="basic-addon2"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            {/* Parts List Section */}
                            <div style={{ background: 'white', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
                                <div style={{ padding: '24px', borderBottom: '1px solid #e5e7eb' }}>
                                    <h5 style={{ fontWeight: '600', margin: 0 }}>Parts List ({this.state.totalItems} items)</h5>
                                </div>
                                
                                <div className="table-responsive table-container">
                                    <table className="table table-hover mb-0">
                                        <thead style={{ background: '#f8f9fa' }}>
                                            <tr>
                                                <th style={{ padding: '16px 24px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '60px' }}>Edit</th>
                                                <th style={{ padding: '16px 24px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '120px' }}>Part ID#</th>
                                                <th style={{ padding: '16px 24px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '150px' }}>Category</th>
                                                <th style={{ padding: '16px 24px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'left' }}>Part Name</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.records.filter(p => p.DataType === undefined).map((p, index) => (
                                                <tr key={index} style={{ borderTop: index > 0 ? '1px solid #f3f4f6' : 'none' }}>
                                                    <td style={{ padding: '16px 24px', border: 'none', textAlign: 'center' }}>
                                                        <button 
                                                            className="btn btn-sm btn-outline-primary" 
                                                            onClick={(e) => this.openPage(e, p.RawsId)}
                                                            title="Edit"
                                                        >
                                                            <i className="ti-pencil"></i>
                                                        </button>
                                                    </td>
                                                    <td style={{ padding: '16px 24px', border: 'none', fontWeight: '600', textAlign: 'center' }}>{p.Id}</td>
                                                    <td style={{ padding: '16px 24px', border: 'none', textAlign: 'center' }}>{this.getCategoryByIdRange(p.Id)}</td>
                                                    <td style={{ padding: '16px 24px', border: 'none', textAlign: 'left' }}>
                                                        {p.RawMaterialName}
                                                        {p.is_new_record === 1 && (
                                                            <span style={{
                                                                backgroundColor: '#3b82f6',
                                                                color: 'white',
                                                                fontSize: '10px',
                                                                padding: '2px 6px',
                                                                borderRadius: '4px',
                                                                marginLeft: '8px',
                                                                fontWeight: '600',
                                                                verticalAlign: 'middle'
                                                            }}>NEW</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}


                                            {this.state.records.length === 0 && (
                                                <tr>
                                                    <td colSpan="4" style={{ padding: '32px', textAlign: 'center', color: '#6b7280' }}>No Records Found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                {/* Pagination */}
                                <div className="pagination-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 24px', borderTop: '1px solid #e5e7eb' }}>
                                    <div className="pagination-info" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                        <div className="input-group" style={{ width: 'auto' }}>
                                            <select className="custom-select" id="perPageSelect" value={this.state.perPage}
                                                    onChange={(e) => this.onPerPageChange(e)}>
                                                <option value="10">10</option>
                                                <option value="25">25</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                        </div>
                                        <span style={{ color: '#6c757d', fontSize: '14px' }}>
                                            Showing {Math.min((this.state.pageNumber - 1) * this.state.perPage + 1, this.state.totalItems)} to {Math.min(this.state.pageNumber * this.state.perPage, this.state.totalItems)} of {this.state.totalItems} entries
                                        </span>
                                    </div>
                                    <PaginatedItems total={this.state.totalItems}
                                                    onPageChange={this.paginatePage}
                                                    currentPage={this.state.pageNumber}
                                                    pageSize={this.state.perPage}></PaginatedItems>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

            </Layout>
        );
    }
}

export default Raws;
